import React from "react";
import { PortalLanguageProvider, usePortalLanguage } from "@/contexts/PortalLanguageContext";

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <PortalLanguageProvider>{children}</PortalLanguageProvider>;
};

export function useLanguage() {
  const { language, setLanguage, t } = usePortalLanguage();
  return { language, setLanguage, t };
}
